import React, { useEffect } from "react";
import UserScreenWindow from "../Components/UserScreenWindow";
import { getAllDocs } from "../../../utils/firebase/Firebase.utils";
import SupplierContactCard from "./SupplierContactCard";
import { FaSearch } from "react-icons/fa";
import { appName, companyName } from "../../../utils/constants";

export default function Suppliers() {
  const [suppliers, setSuppliers] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [searchTerm, setSearchTerm] = React.useState("");

  useEffect(() => {
    const fetchSuppliers = async () => {
      const suppliers = await getAllDocs("suppliers");
      //sort by name
      suppliers.sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
      setSuppliers(suppliers);
      setIsLoading(false);
    };
    fetchSuppliers();
  }, []);

  const servicesTypes = suppliers.map((supplier) => supplier.services[0]);
  //unique services
  const uniqueServices = [...new Set(servicesTypes)];

  const filteredItems = suppliers.filter((supplier) => {
    return (
      supplier?.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      supplier?.services[0].toLowerCase().includes(searchTerm.toLowerCase())
    );
  });

  return (
    <UserScreenWindow label="Suppliers">
      <div className="min-h-screen p-4 md:p-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">
            <h1 className="text-lg font-semibold text-[#363062]">Suppliers</h1>
            <div className="relative w-full md:w-64">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <FaSearch className="text-gray-400 w-4 h-4" />
              </div>
              <input
                type="search"
                className="w-full pl-10 pr-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#363062]/20 focus:border-[#363062]"
                placeholder="Search suppliers..."
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>

          <div className="flex flex-col items-start justify-center gap-2">
            {filteredItems.map((supplier, index) => (
              <div key={index} className="w-full">
                <SupplierContactCard supplier={supplier} />
              </div>
            ))}
          </div>

          <div className="mt-8 p-4 bg-gray-50 rounded-lg">
            <div className="text-sm font-medium text-[#363062] mb-2">
              DISCLAIMER
            </div>
            <p className="text-xs text-gray-600">
              <span className="text-[#363062] font-semibold uppercase">{appName}</span>{" "}
            { ` through this app provides a platform that connects users with
              suppliers. However, ${companyName} is not a party to any transaction or
              agreement between users and suppliers. As such, we do not endorse,
              guarantee, or assume any responsibility for the products,
              services, or actions of any supplier. Users are advised to
              exercise due diligence and caution in their interactions with
              suppliers. ${companyName} shall not be liable for any losses or damages
              resulting from transactions made through the platform. By using
              our platform, you acknowledge that transactions are conducted at
              your own risk.`}
            </p>
          </div>
        </div>
      </div>
    </UserScreenWindow>
  );
}